import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  footer: {
    textAlign: 'center',
  },
}));
